// extracted by css-extract-rspack-plugin
export default {"selectorButton":"McpPermissionModeSelector-module__selectorButton__wdPwe"};